import httpService from "app/services/httpService";
import config from "../../../../src/config.json";

const apiUrl = config.apiUrl;

const addBank = async (values) => {
  try {
    const { data } = await httpService.post(`${apiUrl}/banks`, values);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getBankList = async () => {
  try {
    const { data } = await httpService.get(`${apiUrl}/banks`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const allGetBankList = async () => {
  try {
    const data = await httpService.get(`${apiUrl}/banks/all`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const bankUpdate = async (id, value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/banks/update/${id}`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getVirtualBankList = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/virtualbank/virtual-transaction-list${
        query ? `?${query}` : ""
      }`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const exportVirtualBankList = async (queryString) => {
  try {
    const url = `${apiUrl}/virtualbank/virtual-transaction-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteBanks = async (bankId) => {
  try {
    const url = `${apiUrl}/banks/delete/${bankId}`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};
export {
  addBank,
  getBankList,
  allGetBankList,
  bankUpdate,
  getVirtualBankList,
  exportVirtualBankList,
  deleteBanks,
};
